module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAALBAMAAABBvoqbAAAAKlBMVEUAAADDw8jDw8jDw8jDw8jDw8jDw8jDw8jDw8jDw8jDw8jDw8jDw8jDw8haGoHfAAAADXRSTlMA1w8Wxh7dzL69MRq//EO/gAAAAC1JREFUCNdjWGHAwMAwVxhIqF/cwMDA5CsKZKpcC2BgYL57AMwCiYFlIerAOgA6Xwtd5MfYFQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./components/Icon/images/icon_next1.png
// module id = KCv/
// module chunks = 9